import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const Container = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const WideViewIconContainer = styled("div")`
    display: flex;
    height: 100%;
    align-items: center;
    img {
        width: auto;
        height: auto;
        object-fit: scale-down;
    }

    @media (max-width: ${breakpoints.values.md - 0.2}px) {
        display: none;
    }
`
export const NarrowViewIconContainer = styled("div")`
    display: flex;
    height: 100%;
    justify-content: center;
    img {
        width: auto;
        height: auto;
        max-width: 100%;
        object-fit: scale-down;
    }

    @media (min-width: ${breakpoints.values.md - 0.2}px) {
        display: none;
    }
`
export const BrandIconContainerWrapper = styled("a")`
    display: flex;
    height: 100%;
`
